import type { Payment, PlayerFieldNames } from 'payments-lib-types';
import { required, validateName } from '@/helpers/validators';
import type { REASON_FOR_UPDATING_USER } from '@/store/commonStore/slices/auth/helpers';
import type { PersistentFormName } from '@/store/commonStore/slices/persistant/usePersistentFormsSlice';

export interface IProfileInfoFormData {
  firstName?: string;
  lastName?: string;
  country?: string;
  state?: string;
  address?: string;
  city?: string;
  postalCode?: string;
  dateOfBirth?: {
    day: string;
    month: string;
    year: string;
  };
  mobilePhone?: {
    code: string;
    number: string;
  };
}

interface TextFieldConfig {
  name: string;
  labelKey: string;
  validate?: typeof required;
}

export const TEXT_FIELDS: Partial<Record<PlayerFieldNames, TextFieldConfig>> = {
  first_name: {
    name: 'firstName',
    labelKey: 'auth.registration.form.firstName',
    validate: validateName,
  },
  last_name: {
    name: 'lastName',
    labelKey: 'auth.registration.form.lastName',
    validate: validateName,
  },
  city: {
    name: 'city',
    labelKey: 'auth.registration.form.city',
    validate: required,
  },
  address: {
    name: 'address',
    labelKey: 'auth.registration.form.address',
    validate: required,
  },
  postal_code: {
    name: 'postalCode',
    labelKey: 'auth.registration.form.postalCode',
    validate: required,
  },
};

export const APPEARANCE_FIELDS: [PlayerFieldNames, string][] = [
  ['first_name', 'first_name'],
  ['last_name', 'last_name'],
  ['date_of_birth', 'date_of_birth'],
  ['mobile_phone', 'phone_number'],
  ['state', 'state'],
  ['city', 'city'],
  ['address', 'address'],
  ['postal_code', 'postal_code'],
];

export interface IProfileInfoStepAppearance {
  payment_method: {
    brand: string;
    provider: string;
    id: string;
    type: string;
  };
  fields: string[];
}

export interface IProfileInfoStepResult {
  status: 'success' | 'failed';
  error_data?: string;
}

export interface ProfileInfoConfig {
  paymentAction: Payment.Action;
  persistFormName: PersistentFormName;
  saveKey: string;
  fetchUserReason: REASON_FOR_UPDATING_USER;
  sendAppearanceEvent: (payload: IProfileInfoStepAppearance) => void;
  sendResultEvent: (payload: IProfileInfoStepResult) => void;
}
